export const envBaseUrls = {
  production: 'http://vitalstatistix.launchdarkly.com',
  staging: 'http://vitalstatistix-stg.launchdarkly.com',
  federalStaging: 'http://vitalstatistix.stg.launchdarkly.us',
  federalProduction: 'http://vitalstatistix.launchdarkly.us',
  euProduction: 'http://vitalstatistix.eu.launchdarkly.com',
  catamorphic: 'http://vitalstatistix.ld.catamorphic.com',
  localHost: 'http://localhost:5001',
};
